import PropTypes from 'prop-types';
var RequestStatusTypes;
(function (RequestStatusTypes) {
  RequestStatusTypes["UNINITIALIZED"] = "UNINITIALIZED";
  RequestStatusTypes["PENDING"] = "PENDING";
  RequestStatusTypes["SUCCEEDED"] = "SUCCEEDED";
  RequestStatusTypes["FAILED"] = "FAILED";
})(RequestStatusTypes || (RequestStatusTypes = {}));
export const RequestStatusPropType = PropTypes.oneOf(Object.keys(RequestStatusTypes));
export default RequestStatusTypes;